import React, { createContext, useContext, useState, useEffect } from "react";
import { isServer } from "../global";

export interface WindowDimensions {
  width: number | null;
  height: number | null;
}
const WindowDimensionsCtx = createContext<null | WindowDimensions>(null);

const WindowDimensionsProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [dimensions, setDimensions] = useState(
    !isServer()
      ? {
          width: window.innerWidth,
          height: window.innerHeight
        }
      : null
  );

  useEffect(() => {
    if (!window) {
      return;
    }

    const handleResize = () => {
      setDimensions(
        !isServer()
          ? {
              width: window.innerWidth,
              height: window.innerHeight
            }
          : null
      );
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <WindowDimensionsCtx.Provider value={dimensions}>
      {children}
    </WindowDimensionsCtx.Provider>
  );
};

export default WindowDimensionsProvider;

export const useWindowDimensions = () => useContext(WindowDimensionsCtx);
